<orbit-dialog-header [title]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.TITLE' | translate" />

<div class="edit-participant-dialog">
  <div class="dialog-content">
    <form [formGroup]="editParticipantForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="displayName">
          {{ 'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.DISPLAY_NAME' | translate }}
        </label>
        <orbit-form-field
          type="text"
          id="displayName"
          [controller]="displayName"
          placeholder="{{
            'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.DISPLAY_NAME_PLACEHOLDER' | translate
          }}" />
      </div>

      @if (role() === participantKindEnum.Client) {
        <div class="form-group">
          <label for="phone">
            {{ 'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.PHONE' | translate }}
          </label>
          <orbit-form-field
            type="tel"
            id="phone"
            [controller]="phoneNumber"
            placeholder="{{
              'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.PHONE_PLACEHOLDER' | translate
            }}" />
        </div>
      }

      @if (role() === participantKindEnum.Client) {
        <div class="form-group">
          <label for="email">
            {{ 'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.EMAIL' | translate }}
          </label>
          <orbit-form-field
            type="email"
            id="email"
            [controller]="email"
            placeholder="{{
              'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.EMAIL_PLACEHOLDER' | translate
            }}" />
        </div>
      }
      @let _errors = errors();
      <div class="error-wrapper">
        @for (error of _errors; track error.id) {
          <orbit-message [message]="error.message ?? error.code | translate" [severity]="'error'" />
        }
      </div>
    </form>
  </div>

  <orbit-dialog-footer>
    <div class="right-addon" right-addon>
      <orbit-button
        [flat]="true"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CANCEL_LABEL' | translate"
        (click)="onCancel()" />
      <orbit-button
        [disabled]="editParticipantForm.invalid || isSubmitting()"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CONFIRM_LABEL' | translate"
        (onClick)="onSubmit()" />
    </div>
  </orbit-dialog-footer>
</div>
